import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {gp_sheet_template} from "../components/templates/gp_sheet_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class gp_sheet extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected gp_sheet_template: gp_sheet_template;

    protected getModuleName(){
        return "gp_sheet";
    }

    buildContent() : Array<Element>{

        this.gp_sheet_template = new gp_sheet_template( "gp_sheet", this.viewModel, this );
        this.template = this.gp_sheet_template;

        return [this.gp_sheet_template.build()];
    }

    public fillPage() : void{
        this.gp_sheet_template.buildDatePickerCalendar();

        // First get the presets
        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/gp_sheet/list_form_data';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    public getListData(): void{

        this.loadingIn(this.gp_sheet_template.builtTemplate.children.namedItem("list-results"));
        this.gp_sheet_template.getTemplateViewModel().viewModeLoading(true);

        let subViewModel = this.gp_sheet_template.getViewModelForRequest();
        let baseApiUrl = '/api/gp_sheet/list_data';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onFilterRequestReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.gp_sheet_template.validationsList.clearMessages();

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.loadSuspiciousTrafficExclusions();
                obj.getListData();
            });

            if(req.request.readyState == 4){
                if (req.request.status == 200) {
                    // LOADING : ends
                    obj.loadingOut(obj.gp_sheet_template.builtTemplate);
                }
            }
        }
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.gp_sheet_template.resetSelectedRows();
                obj.gp_sheet_template.validationsList.clearMessages();
                obj.updateList(responseParsed.tableData);
                obj.gp_sheet_template.setGpAggInProgress(responseParsed.inProgress);
                obj.gp_sheet_template.setIsDefaultFilters(responseParsed.isDefaultFilters);

                for(let item of responseParsed.outstreamRatios){

                    if(obj.gp_sheet_template.getTemplateViewModel().displayModeSelected() == 'date'){

                        item.date = obj.formatDate(item.dateData + "T12:00:00");
                    }
                }

                obj.gp_sheet_template.setOutstreamRatioData(responseParsed.outstreamRatios);

                if(obj.gp_sheet_template.getTemplateViewModel().displayModeSelected() == 'date' && obj.gp_sheet_template.getTemplateViewModel().viewModeSelected() == 'daily'){

                    obj.getTasksProgress();
                }
            });

            if(req.request.readyState == 4){
                if (req.request.status == 200) {
                    obj.loadingOut(obj.gp_sheet_template.builtTemplate.children.namedItem("list-results"));
                    obj.gp_sheet_template.getTemplateViewModel().viewModeLoading(false);
                }
            }
        }
    }

    public getTasksProgress(): void{

        let usrReq_url: string = '/api/gp_sheet/tasks_progress_data';
        let usrReq_params: Array<Array<string>> = [];
        let subViewModel = this.gp_sheet_template.getViewModelForRequest();
        usrReq_params.push(['data', ko.toJSON(subViewModel)]);

        let XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        XHRHdl.onReadyStateFunction = this.onTasksProgressRequestReturn;
        XHRHdl.execute();
    }

    protected onTasksProgressRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                    obj.gp_sheet_template.validationsList.clearMessages();
                    obj.updateTasksProgress(responseParsed);
            });
        }
    }

    protected updateTasksProgress(responseParsed: any){

        if(this.gp_sheet_template.getTemplateViewModel().displayModeSelected() == 'date' && this.gp_sheet_template.getTemplateViewModel().viewModeSelected() == 'daily'){

            let gpData = this.gp_sheet_template.getTemplateViewModel().gpData();

            for(let i = 0; i < gpData.length; i++){

                let isoDate = gpData[i].date.slice(-10);

                for(let j = 0; j < gpData[i].revenueData.length; j++){

                    if(gpData[i].revenueData[j].headerType != undefined && gpData[i].revenueData[j].headerName != undefined && gpData[i].revenueData[j].headerType == 'brand'){

                        let key = isoDate + '|' + gpData[i].revenueData[j].headerName;
                        if(responseParsed[key] !== undefined){

                            let entry = responseParsed[key];
                            let message;
                            let color;
                            if(entry.idStatus === null){

                                message = "Recalculation scheduled for " + entry.dateScheduled;
                                color = '#fffbd2';
                            }else if(entry.idStatus == 1){

                                message = "Recalculation in progress, started at " + entry.dateExecuted;
                                color = '#fac9d9';
                            }

                            gpData[i].revenueData[j]['progressTooltip'] = message;
                            gpData[i].revenueData[j]['progressBackgroundColor'] = color;
                        }
                    }
                }
            }

            // Need to clear the observable before setting it again for the data binding to detect change
            this.gp_sheet_template.setGpData([]);
            this.gp_sheet_template.setGpData(gpData);
        }
    }

    protected updateFilters(responseParsed: any){

        this.gp_sheet_template.setBrandFilterItems(responseParsed.portfolios);
        this.gp_sheet_template.setAvailableBrandsOptions(responseParsed.brands || []);
        this.gp_sheet_template.setCanManageSuspiciousTrafficExclusions(
            responseParsed.canManageSuspiciousTrafficExclusions === true
        );
        this.gp_sheet_template.setSuspiciousTrafficVariantsStartDate(
            responseParsed.suspiciousTrafficVariantsStartDate || ''
        );
        this.gp_sheet_template.setSegmentsFilterItems(responseParsed.segments);
        this.gp_sheet_template.setCountriesFilterItems(responseParsed.countries);
        this.gp_sheet_template.setTemplateFilterItems(responseParsed.templates);
        this.gp_sheet_template.setTrafficTypeFilterItems();
        this.gp_sheet_template.setViewModesItems();
        this.gp_sheet_template.setRevenueOptionsFilterItems();
        this.gp_sheet_template.setDisplayModeOptionsFilterItems();
        this.gp_sheet_template.setDeviceOptionsFilterItems();
        this.gp_sheet_template.setMobileOsOptionsFilterItems();
        this.gp_sheet_template.setIntentGroupingFilterItems();
        this.gp_sheet_template.setDirectAdvertiserNamesArray();
    }

    protected filterMultipleSelectorOnChange(){
        this.getListData();
    }

    protected filterDateOnChange(){
        this.getListData();
        this.loadSuspiciousTrafficExclusions();
    }

    public loadSuspiciousTrafficExclusions(): void {
        let subViewModel = this.gp_sheet_template.getViewModelForRequest();
        let usrReq_url: string = '/api/gp_sheet/suspicious_traffic_exclusions';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['data', ko.toJSON({
            dateStart: subViewModel.startDate,
            dateEnd: subViewModel.endDate,
        })]);

        this.gp_sheet_template.getTemplateViewModel().suspiciousTrafficSettingsLoading(true);
        let XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        XHRHdl.onReadyStateFunction = this.onSuspiciousTrafficExclusionsReturn;
        XHRHdl.execute();
    }

    protected onSuspiciousTrafficExclusionsReturn(req: any, obj: any) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.gp_sheet_template.setSuspiciousTrafficExclusions(responseParsed.items || []);
            });

            if (req.request.readyState == 4) {
                obj.gp_sheet_template.getTemplateViewModel().suspiciousTrafficSettingsLoading(false);
            }
        };
    }

    public saveSuspiciousTrafficExclusion(payload: { idBrand: number | string, dateData: string }): void {
        let usrReq_url: string = '/api/gp_sheet/suspicious_traffic_exclusions/save/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['data', ko.toJSON(payload)]);

        this.gp_sheet_template.getTemplateViewModel().suspiciousTrafficSettingsLoading(true);
        let XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSuspiciousTrafficExclusionSaveReturn;
        XHRHdl.execute();
    }

    protected onSuspiciousTrafficExclusionSaveReturn(req: any, obj: any) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    'Suspicious traffic exclusion saved.'
                );
                obj.getVnAppZone().showNotificationToModule();
                obj.gp_sheet_template.getTemplateViewModel().suspiciousTrafficExclusionDate('');
                obj.loadSuspiciousTrafficExclusions();
                obj.getListData();
            });

            if (req.request.readyState == 4) {
                obj.gp_sheet_template.getTemplateViewModel().suspiciousTrafficSettingsLoading(false);
            }
        };
    }

    public deleteSuspiciousTrafficExclusion(payload: { idBrand: number, dateData: string }): void {
        let usrReq_url: string = '/api/gp_sheet/suspicious_traffic_exclusions/delete/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['data', ko.toJSON(payload)]);

        this.gp_sheet_template.getTemplateViewModel().suspiciousTrafficSettingsLoading(true);
        let XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSuspiciousTrafficExclusionDeleteReturn;
        XHRHdl.execute();
    }

    protected onSuspiciousTrafficExclusionDeleteReturn(req: any, obj: any) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    'Suspicious traffic exclusion deleted.'
                );
                obj.getVnAppZone().showNotificationToModule();
                obj.loadSuspiciousTrafficExclusions();
                obj.getListData();
            });

            if (req.request.readyState == 4) {
                obj.gp_sheet_template.getTemplateViewModel().suspiciousTrafficSettingsLoading(false);
            }
        };
    }

    protected getValStreamArrayIndexes(headers){

        let indexes = [];

        for (let i = 0; i < headers.length ; i++) {

            let header = headers[i];
            if(header.name.indexOf('ValStream_') !== -1){

                indexes.push(i);
            }
        }

        return indexes;
    }

    protected moveIndexesToEndOfElements(elements, indexesToBeRelocated){

        for(let i = 0; i < indexesToBeRelocated.length ; i++){

            // Subtracting i because as we move entries to the end of the array, the index shift as well.
            let index = indexesToBeRelocated[i] - i;

            // Move element to end of array
            elements.push(elements.splice(index, 1)[0]);
        }

        return elements;
    }

    protected updateList(responseParsed: any){

        if(this.gp_sheet_template.getTemplateViewModel().viewModeSelected()=='brands'){


            this.gp_sheet_template.setBrandGpData(responseParsed.brandGpSheetData);
            this.gp_sheet_template.setGpData([]);
            this.gp_sheet_template.setGpZoneData([]);
            this.gp_sheet_template.setPortfolioSubtotal(responseParsed.portfolioSubtotal);
        }
        else {

            // Reorder ValStream so that it is always at the end of the advertisers
            let valStreamIndexes = this.getValStreamArrayIndexes(responseParsed.revenueHeaders);
            responseParsed.revenueHeaders = this.moveIndexesToEndOfElements(responseParsed.revenueHeaders, valStreamIndexes)

            for(let item of responseParsed.gpSheetDatas){

                if(this.gp_sheet_template.getTemplateViewModel().displayModeSelected() == 'date'){

                    item.date = item.date == "TOTAL" ? item.date : this.formatDate(item.date + "T12:00:00");
                }

                // Reorder ValStream so that it is always at the end of the advertisers
                item = this.moveIndexesToEndOfElements(item.revenueData, valStreamIndexes);
            }

            if(this.gp_sheet_template.getTemplateViewModel().viewModeSelected()=='zones'){

                if(this.gp_sheet_template.getTemplateViewModel().zonesModeGrouping() == 'daily'){

                    this.gp_sheet_template.setGpZoneData(responseParsed.gpSheetDatas);
                    

                }else if(this.gp_sheet_template.getTemplateViewModel().zonesModeGrouping() == 'brands'){

                    this.gp_sheet_template.setGpZoneDataForBrands(responseParsed.brandGpSheetData);
                    this.gp_sheet_template.setPortfolioSubtotalForZones(responseParsed.portfolioSubtotal);
                }

                this.gp_sheet_template.setGpData([]);
            }else{

                this.gp_sheet_template.setGpZoneData([]);
                this.gp_sheet_template.setGpData(responseParsed.gpSheetDatas);

            }

            this.gp_sheet_template.setBrandGpData([]);
        }

        this.gp_sheet_template.setHeaders(responseParsed.revenueHeaders, responseParsed.gpsHeaders, ('portfolioHeaders' in responseParsed) ? responseParsed.portfolioHeaders : []);
        this.gp_sheet_template.setSegmentsFilterItems(responseParsed.segments);

    }

    protected formatDate(date) {
        let weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";

        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            dayOfWeek = weekday[d.getDay()];


        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return dayOfWeek + ', ' + [year, month, day].join('-');
    }
}



// WEBPACK FOOTER //
// ./js/modules/gp_sheet.ts